const resetNotebook = (state) => {
  state.notebookPages = [
    '',
    '',
    '',
    ''
  ]

  return state
}

export default {

  state: resetNotebook({}),

  getters: {

    notebookPages ({ notebookPages }) {
      return notebookPages
    },

    lastNotebookPageIndex ({ notebookPages }) {
      return notebookPages.length - 1
    },

    notebookPageByIndex ({ notebookPages }) {
      return (i) => {
        return notebookPages[i]
      }
    }

  },

  mutations: {

    resetNotebook,

    setNotebookPageContent (state, { i, content }) {
      state.notebookPages[i] = content.trim()
    }

  },

  actions: {

    setNotebookPageContent ({ commit }, { i, content }) {
      commit('setNotebookPageContent', {
        i,
        content
      })
    }

  }

}
